// Auto-generate a 6-photo gallery per destination.
// Photo 1 is the curated hero image (guaranteed relevant); photos 2–6 use
// hand-picked, themed photo pools (themePhotos.js) so every shot is beautiful
// and on-topic, with a stable per-destination offset for variety.

import { photoFromPool } from "./themePhotos";

const GALLERY_THEMES = {
  travel: [
    { kw: "architecture", cap: "Old-town streets and architecture" },
    { kw: "coast", cap: "The coastline at golden hour" },
    { kw: "food", cap: "Plates from family-run kitchens" },
    { kw: "landmark", cap: "Landmarks worth the detour" },
    { kw: "sunset", cap: "Sunset over the rooftops" },
  ],
  yoga: [
    { kw: "yoga", cap: "Morning practice with a view" },
    { kw: "meditation", cap: "Quiet space for meditation" },
    { kw: "nature", cap: "Silent walks through nature" },
    { kw: "food", cap: "Plant-based, farm-to-table meals" },
    { kw: "spa", cap: "Deep restoration between sessions" },
  ],
  wellness: [
    { kw: "beach", cap: "Sun-soaked days by the water" },
    { kw: "spa", cap: "Spa rituals and slow mornings" },
    { kw: "rooftop", cap: "Golden-hour drinks and views" },
    { kw: "nightlife", cap: "Electric nights out" },
    { kw: "sunset", cap: "Rooftop sunsets to remember" },
  ],
  adventure: [
    { kw: "hiking", cap: "Trails with a certified guide" },
    { kw: "mountain", cap: "The reward at the summit" },
    { kw: "river", cap: "Raw, humbling landscapes" },
    { kw: "forest", cap: "Wildlife and photography stops" },
    { kw: "snow", cap: "Refuge stays under the stars" },
  ],
};

const hashOffset = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

export function getGallery(parent) {
  const themes = GALLERY_THEMES[parent.category] || GALLERY_THEMES.travel;
  const off = hashOffset(parent.id);
  const heroPhoto = {
    id: `${parent.id}-photo-1`,
    src: parent.image,
    caption: `${parent.title}, ${parent.country}`,
  };
  const themed = themes.map((t, i) => ({
    id: `${parent.id}-photo-${i + 2}`,
    src: photoFromPool(t.kw, off + i),
    caption: `${t.cap} in ${parent.title}`,
  }));
  return [heroPhoto, ...themed];
}
